import Grid from '@mui/material/Grid';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { stateApiKeyStore } from '../../../api/states-api-key-store';
import { FormInputTime } from '../../../components/hook-form/form-input.time.component';

export const MunicipalityForm = () => {
  const options = [
    {
      value: 'active',
      label: 'Active',
      isDefault: true,
    },
    {
      value: 'inactive',
      label: 'Inactive',
      isDefault: false,
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormSelectDynamic
          name="stateID"
          label="State"
          getQueryKeyConfig={() => stateApiKeyStore.getStates()}
          optionsValueKey="stateID"
          optionsLabelKeys={['stateName']}
        />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Municipality Name" name="muncipalityName" maxLength={150} multiline={false} autoFocus />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Code" name="municipalityCode" maxLength={150} multiline={false} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInputTime name="cutOffTime" label="Cut-off Time" />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormSelect label="Status" name="status" options={options} />
      </Grid>
    </Grid>
  );
};
